var template = require('../templates/PayrollItemSelectionButton.html');

module.exports = Backbone.View.extend({
    tagName: 'div',

    events: {
        'click': 'toggleSelect'
    },

    initialize: function(options) {
        var self = this;

        self.options = _.defaults(options || {}, {
            additionalInfo: null
        });

        self.model.on('change', self.render, self);
        self.render();
    },

    render: function() {
        var self = this;

        self.$el
            .addClass('btn btn-outline btn-default btn-item')
            .html(template({
                model: self.model,
                additionalInfo: self.options.additionalInfo
            }));
        self.$el.toggleClass('selected js-selected', self.model.isSelected());
    },

    remove: function() {
        var self = this;
        if (_.isFunction(Backbone.View.prototype.remove)) {
            Backbone.View.prototype.remove.apply(self, arguments);
        }

        self.model.off('change', self.render);
        self.undelegateEvents();
    },

    toggleSelect: function(ev) {
        ev.preventDefault();

        var self = this;

        self.model.toggleSelect();
        self.$el.toggleClass('selected js-selected', self.model.isSelected());
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/PayrollItemSelectionButton.js